import { MapMarker } from "@/migrated-widgets/table-map/components/molecules/Map/types";

class GeoUtils {
    static generateNewPositionAroundCollision(markerPosition: google.maps.LatLngLiteral, distance: number): google.maps.LatLngLiteral {
        // Generate a random angle
        const angle = Math.random() * Math.PI * 2;
        // Calculate new position offset by the given distance
        const newLat = markerPosition.lat + distance * Math.cos(angle);
        const newLng = markerPosition.lng + distance * Math.sin(angle);
        return { lat: newLat, lng: newLng };
    }

    static collisionDetection(alreadyRenderedMarker: MapMarker, toRenderMarker: MapMarker, diameter: number = 10) {
        const distanceBetweenCenters = Math.sqrt(
            Math.pow(toRenderMarker.position.lat - alreadyRenderedMarker.position.lat, 2) +
                Math.pow(toRenderMarker.position.lng - alreadyRenderedMarker.position.lng, 2),
        );

        return distanceBetweenCenters <= diameter;
    }

    static relocateMarkerPosition(
        toRenderMarker: MapMarker,
        distance: number = 0.01, // Default distance from the collision marker
    ) {
        const newPosition = this.generateNewPositionAroundCollision(toRenderMarker.position, distance);
        return newPosition;
    }

    /**
     * Returns the marker's visual radius in pixels based on its totalSold count.
     * Mirrors the Tailwind sizing tiers used in MapSide.tsx.
     */
    static getMarkerPixelRadius(totalSold: number): number {
        if (totalSold <= 1) return 12;   // w-6  = 24px
        if (totalSold <= 5) return 14;   // w-7  = 28px
        if (totalSold <= 15) return 16;  // w-8  = 32px
        if (totalSold <= 30) return 18;  // w-9  = 36px
        if (totalSold <= 50) return 20;  // w-10 = 40px
        if (totalSold <= 75) return 22;  // w-11 = 44px
        if (totalSold <= 100) return 24; // w-12 = 48px
        return 26;                       // w-13 = 52px
    }

    /**
     * Returns how many meters correspond to one CSS pixel at the given
     * map zoom level and latitude (Web Mercator projection formula).
     */
    static metersPerPixelAtZoom(lat: number, zoom: number): number {
        return (156543.03392 * Math.cos((lat * Math.PI) / 180)) / Math.pow(2, zoom);
    }

    /**
     * Returns true if `point` is within `radiusMeters` of `center`.
     * Uses the Haversine formula for accurate geodetic distance.
     */
    static isInsideCircle(
        point: google.maps.LatLngLiteral,
        center: google.maps.LatLngLiteral,
        radiusMeters: number,
        bufferMeters: number = 0,
    ): boolean {
        const R = 6371000; // Earth radius in meters
        const φ1 = (center.lat * Math.PI) / 180;
        const φ2 = (point.lat * Math.PI) / 180;
        const Δφ = ((point.lat - center.lat) * Math.PI) / 180;
        const Δλ = ((point.lng - center.lng) * Math.PI) / 180;
        const a =
            Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c <= radiusMeters + bufferMeters;
    }
}

export { GeoUtils };
